<div class="form-group row" [ngClass]="divClass">
  <label [for]="inputId" *ngIf="!suppressLabel" class="col-form-label" [ngClass]="labelClass || 'col-12 col-sm-4'">
    {{ translateTag | translate }}
    <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
  </label>
  <div class="col d-flex align-items-center justify-content-center">
    <input
      type="radio"
      class="form-check-input standard-radio"
      [ngClass]="renderStatic ? 'form-control-plaintext' : 'form-control'"
      [readonly]="renderStatic"
      [id]="inputId"
      [name]="radioGroupName || gungTranslate"
      [required]="required"
      [disabled]="disabled"
      [checked]="value === buttonValue"
      (change)="onRadioChange($event)"
      [value]="buttonValue"
    />
  </div>
</div>
